import './App.css';
import '../node_modules/bulma/css/bulma.css';
import Home from './pages/Home/Home';
import Success from './pages/Success/Success';
import Canceled from './pages/Canceled/Canceled';
import Download from './pages/Success/Download';
import {Route, BrowserRouter as Router, Switch} from 'react-router-dom';

function App() {
  return (
    <>
    <Router>
      <Switch>
        <Route path="/" exact component={Home}/>
        <Route path="/success" component={Success}/>
        <Route path="/canceled" component={Canceled}/>
        <Route path="/download12365hgf8469475qopeldnsjdedsdd18z4f5ezfezdz54sz98d4dsqdfe846" component={Download}/>
      </Switch>
    </Router>
    </>
     
  );
}

export default App;
